import {WORKFLOW_ACTIONS} from "../components/workflow-bar/constants/WorkflowActions";
import {IgenomicsAction} from "../../core/interfaces/genomics-action.interface";
import {CORE_ACTIONS} from "@ispm/core/constants/core-actions.constant";

export interface WorkflowBarItem {
  name: string;
  isActive?: boolean;
  tooltip?: string;
  pos?: string;
  fromStatus?: boolean;
  showLastStateChange?: boolean;
  conditionPrevStepDone?: string;
  isSkipped?: boolean;
  singleStep?: boolean;
}

export interface ISharedState {
  workflow_bar: Array<WorkflowBarItem>;
  workflow_status: string;
}

const sharedInitState: ISharedState = {
  workflow_bar: null,
  workflow_status: null
};

export function sharedReducer(state: ISharedState = sharedInitState, action: IgenomicsAction): ISharedState {
  let newState;
  switch (action.type) {
    case WORKFLOW_ACTIONS.UPDATE_BAR:
      newState = Object.assign({}, state, action.payload);
      return newState;
    case WORKFLOW_ACTIONS.INIT_BAR:
    case CORE_ACTIONS.CLEAR_ALL_CACHED_ITEMS:
      newState = Object.assign({}, state, {workflow_bar: null, workflow_status: null});
      return newState;
    default:
      return state;
  }
}
